import { configureStore } from '@reduxjs/toolkit'
import { PropsWithChildren } from 'react'
import { Provider, TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { beltSlice } from './beltSlice'
import { challengeSlice } from './challengeSlice'
import { configSlice } from './configSlice'
import { studentSlice } from './studentSlice'
import { userSlice } from './userSlice'
import { videoSlice } from './videoSlice'

export const store = configureStore({
  reducer: {
    [configSlice.name]: configSlice.reducer,
    [beltSlice.name]: beltSlice.reducer,
    [challengeSlice.name]: challengeSlice.reducer,
    [userSlice.name]: userSlice.reducer,
    [studentSlice.name]: studentSlice.reducer,
    [videoSlice.name]: videoSlice.reducer
  },
  devTools: true
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const withProvider = ({ children }: PropsWithChildren<Record<string, unknown>>) => {
  return <Provider store={store}>{children}</Provider>
}

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
